import { EditProps } from "react-admin";
import { DefaultEdit } from "../../../../lib/components";
import {
  MediaFileSource,
  transformAndUploadS3Files,
} from "../../../../lib/modules";

import { ItemSegmentForm } from "./ItemSegmentForm";

const ItemSegmentEdit= (props:EditProps) => {
  const mediaFileSources: MediaFileSource[] = [
    {
      source: "files",
      subFolder: "itemSegments",
    },
  ];
  return (
    <DefaultEdit
      {...props}
      mutationMode="pessimistic"
      transform={transformAndUploadS3Files(mediaFileSources)}
    >
      <ItemSegmentForm isEdit={true}{...props} />
    </DefaultEdit>
  );
};

export { ItemSegmentEdit };
